import thumb_up from "../images/thumb_up.svg";
import thumb_down from "../images/thumb_down.svg";
import {keydownHandler} from "../utils/commonHelper";
import React, {useEffect, useState, useRef, useMemo} from 'react'
import {Oval} from "react-loader-spinner";
import TextareaAutosize from "react-textarea-autosize";

export const FeedbackBaseConfig = {
    thumbUp: {
        value: 1,
        className: 'thumb-up',
        loader: {
            width: 24,
            height: 24
        },
        component: <img src={thumb_up} alt=""/>
    },
    thumbDown: {
        value: 0,
        className: 'thumb-down',
        loader: {
            width: 24,
            height: 24
        },
        component: <img src={thumb_down} alt=""/>
    }
};

const Feedback = ({contactId, onUpdateFeedback, feedbackLoaderStatus, ...props}) => {
    const [isShown, setIsShown] = useState(false);
    const [chatEnded, setChatEnd] = useState(!!props.agents[contactId]?.chatEnded)

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsShown(true);
        }, props.waitBeforeShow);
        return () => clearTimeout(timer);
    }, [props.waitBeforeShow]);
    useEffect(() => {
        props.scrollToBottom();
    }, [isShown])

    const [config, setConfig] = useState(props.feedbackConfig ? props.feedbackConfig : FeedbackBaseConfig);
    const [feedbackValue, setFeedbackValue] = useState(props.feedbackValue?.[contactId]);
    useEffect(() => {
        setFeedbackValue(props.feedbackValue)
    }, [props.feedbackValue])
    const changeRating = (question, rating) => {
        onUpdateFeedback({
            ...feedbackValue,
            [contactId]: {...feedbackValue[contactId], [question]: rating}
        })
    }

    const inputRef = useRef(null);
    const sendMessageButton = useRef(null);

    const getAgentName = useMemo(() => {
        const agentName = props.agents[contactId]?.agentName;
        return (!agentName || agentName === 'SYSTEM_MESSAGE') ? 'agent' : agentName;
    }, [props.agents, contactId]);

    return isShown && <div className={"feedback-box " + (!chatEnded ? "transferring" : "")}>
        <div className={"feedback-content"}>
            {
                (chatEnded || props.showCancelFeedback) && <div className="title">
                    Please help us improve by completing this short feedback survey.
                </div>
            }
            {
                feedbackLoaderStatus === contactId ?
                    <div className={"feedback-loader"}>
                        <Oval
                            type="Oval"
                            color="#02818A"
                            timeout={0}
                        />
                    </div>
                    :
                    ""
            }
            <div>
                {
                    (chatEnded || props.showCancelFeedback) &&
                    <Question config={config} contactId={contactId} changeRating={changeRating}
                              feedbackValue={feedbackValue} questionName={'helpReceived'}
                              questionTitle={'Did you receive the help you needed?'}
                              sendFeedback={props.sendFeedback} chatEnded={chatEnded}
                              showCancelFeedback={props.showCancelFeedback}/>
                }
                <Question config={config} contactId={contactId} changeRating={changeRating}
                          feedbackValue={feedbackValue} questionName={'feedbackResult'}
                          questionTitle={'Please rate your chat with ' + getAgentName}
                          sendFeedback={props.sendFeedback} chatEnded={chatEnded}
                          showCancelFeedback={props.showCancelFeedback}/>
                {
                    (chatEnded || props.showCancelFeedback) &&
                    <>
                        <div className={"feedback-inputs"}>
                            <TextareaAutosize
                                minRows={4}
                                tabIndex={0}
                                autoFocus={true}
                                ref={inputRef}
                                className="chat__input"
                                placeholder={"Additional feedback or comments (optional)"}
                                value={feedbackValue[contactId] ? feedbackValue[contactId].feedbackMessage : ""}
                                onChange={(e) => {
                                    props.changeFeedbackMessage(contactId, e)
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.keyCode === 13) {
                                        e.preventDefault();
                                        props.sendFeedback(contactId);
                                    }
                                }}
                            />
                        </div>
                        <div className={"feedback-buttons"}>
                            <button className="template__href"
                                    tabIndex={0}
                                    ref={sendMessageButton}
                                    onClick={() => {
                                        props.sendFeedback(contactId)
                                    }}
                                    onKeyDown={keydownHandler}>
                                Submit Feedback
                            </button>
                            <a className={"btn_skip"} onClick={()=>props.skipFeedback()}>Skip</a>
                        </div>
                    </>
                }
            </div>
        </div>

    </div>
}

const ThumbsButton = ({
                          config,
                          contactId,
                          changeRating,
                          feedbackValue,
                          questionName,
                          disabled,
                          sendFeedback,
                          chatEnded,
                          showCancelFeedback
                      }) => {
    const onChangeFeedback = (question, rate) => {
        changeRating(question, rate);
    }
    const isSelected = feedbackValue[contactId] && feedbackValue[contactId][questionName] === config.value;
    return (
        <a className={(isSelected ? 'selected' : '') + ' ' + config.className}
           tabIndex={0}
           onKeyDown={keydownHandler}
           disabled={disabled}
           onClick={() => chatEnded || showCancelFeedback ? onChangeFeedback(questionName, config.value) : sendFeedback(contactId, config.value)}>
            {
                config.component
            }
        </a>
    );
}
export const Question = ({
                             config,
                             contactId,
                             changeRating,
                             feedbackValue,
                             questionTitle,
                             questionName,
                             disabled,
                             sendFeedback,
                             chatEnded,
                             showCancelFeedback
                         }) => {

    return <div className="rate-box">
        {questionTitle}
        <div className="thumbs">
            <ThumbsButton
                config={config.thumbUp}
                contactId={contactId}
                changeRating={changeRating}
                feedbackValue={feedbackValue}
                questionName={questionName}
                disabled={disabled}
                sendFeedback={sendFeedback}
                chatEnded={chatEnded}
                showCancelFeedback={showCancelFeedback}
            />
            <ThumbsButton
                config={config.thumbDown}
                contactId={contactId}
                changeRating={changeRating}
                feedbackValue={feedbackValue}
                questionName={questionName}
                disabled={disabled}
                sendFeedback={sendFeedback}
                chatEnded={chatEnded}
                showCancelFeedback={showCancelFeedback}
            />
        </div>
    </div>
}
export default Feedback;
